<template>
  <div style="position: relative;">
    <div class="search-container">
      <el-row class="revise">
        <template v-if="isSingle">
          <div class="search-bar">
            <div>
              <el-select v-model="form.status" class="mobile-select" style="width:105px;">
                <el-option v-for="(status,index) in statusList" :key="index" :label="status.label" :value="status.name"></el-option>
              </el-select>
            </div>
            <div>
              <el-select style="width:100%;"
                v-model="searchMerchant"
                clearable
                filterable
                :filter-method="filterSearch"
                class="input-width"
                @change="handleAutoSelect"
                @clear="handleClear"
                placeholder="商家">
                <el-option
                  v-for="item in merchantOptions"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"></el-option>
              </el-select>
            </div>
            <div>
              <el-select style="width:150px;"
                        v-model="transport_express"
                        clearable
                        filterable
                        :filter-method="remotetransportSearch"
                        class="input-width"
                        @change="transporthandleSelect"
                        placeholder="转运公司">
                        <el-option
                          v-for="item in remoteTrasports"
                          :key="item.id"
                          :label="item.value"
                          :value="item.id"></el-option>
                      </el-select>
            </div>
            <div>
              <el-select class="combo-left" v-model="secondary_type" @change="switchFields" style="width:80px;margin-right:-10px;">
                <el-option label="转运" value="0"></el-option>
                <el-option label="运费" value="1"></el-option>
                <el-option label="异常" value="2"></el-option>
                <el-option label="支付" value="3"></el-option>
              </el-select>
              <el-select v-if="secondary_type=='0'" class="combo-right" v-model="transport_status" placeholder="转运状态" style="width:150px;">
                <el-option
                  v-for="item in transportStatusArray"
                  :key="item.id"
                  :label="item.show"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-if="secondary_type=='1'" class="combo-right" v-model="international_transport_amount_status" placeholder="国际运费状态" style="width:150px;">
                <el-option
                  v-for="item in internationalAmountStatusArray"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-if="secondary_type=='2'" class="combo-right" v-model="order_exception_type" placeholder="异常类型" style="width:150px;">
                <el-option label="异常类型" :value="-1">
                </el-option>
                <el-option label="待回复" :value="-2">
                </el-option>
                <el-option label="无异常" :value="999">
                </el-option>
                <el-option
                  v-for="item in exceptionTypes"
                  :key="item.value"
                  :label="item.content"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-if="secondary_type=='3'" class="combo-right" v-model="payment_type_list" placeholder="支付方式" style="width:150px;">
                <el-option
                  v-for="item in payment_type_list_arr"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div>
              <el-input class="commbo-input" placeholder="用户名" clearable v-model="buyer_name" style="width:265px;">
                <el-select class="search-preix" v-model="buyer_type" slot="prepend" placeholder="请选择" style="width:120px;">
                  <el-option label="用户" value="-1"></el-option>
                  <el-option label="客户" value="5"></el-option>
                  <el-option label="买手" value="1"></el-option>
                  <el-option label="下单委托" value="2"></el-option>
                  <el-option label="商家物流委托" value="3"></el-option>
                  <el-option label="转运物流委托" value="4"></el-option>
                  <el-option label="支付方" value="6"></el-option>
                </el-select>
              </el-input>
              <!--<el-select v-if="role!=0" v-model="buyer_id" placeholder="买手" @change="handleBuyers" style="width:150px;">
                <el-option
                  v-for="item in buyers"
                  :key="item.single_account_id"
                  :label="item.single_username"
                  :value="item.single_account_id">
                </el-option>
              </el-select>-->
            </div>
          </div>
          <div class="search-bar notMobile">
            <span>
              {{totalCount}}个任务&nbsp;&nbsp;
            </span>
            <div style="display:flex;align-items:center;">
              <span v-loading="isExporting"></span>
              <span v-if="isSingle" class="export" @click="exportExcel">{{ isExporting?'导出中':'导出excel' }}</span>
              <div style="margin:0 5px;display: flex;align-items: center;">
                <el-select v-model="sortParams.field" class="combo-left preix-select" style="width:120px;">
                  <template slot="prefix">
                    <i style="line-height:40px;color:#606266;" :class="{'el-icon-bottom':sortParams.field.indexOf('desc')>-1,'el-icon-top':sortParams.field.indexOf('asc')>-1}"></i>
                  </template>
                  <el-option label="创建时间" value="timedesc">
                    <span><i style="margin-left:-5px;" class="el-icon-bottom"></i>创建时间</span>
                  </el-option>
                  <el-option label="创建时间" value="timeasc">
                    <span><i style="margin-left:-5px;" class="el-icon-top"></i>创建时间</span>
                  </el-option>
                </el-select>
                <!--<el-select v-model="form.date" class="mobile-select" style="width:150px;margin-right:13px;">
                  <el-option v-for="(date,index) in dateList" :key="index" :label="date" :value="date"></el-option>
                </el-select>-->
                <span class="combo-right">
                  <el-date-picker style="margin-right:5px;" format="yyyy-MM-dd HH:mm" v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
                    end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" @change="handleTimeChange">
                  </el-date-picker>
                </span>
              </div>
              <el-input class="commbo-input" style="width:460px;" :placeholder="keyword_type=='0'?'':'多个号码请用空格或逗号分隔'" clearable v-model="searchWord">
                <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择" style="width:120px;" @change="changeKeywordType">
                  <el-option label="全文搜索" value="0"></el-option>
                  <el-option label="任务号" value="1"></el-option>
                  <el-option label="商家订单号" value="2"></el-option>
                  <el-option label="商家物流号" value="3"></el-option>
                  <el-option label="转运物流号" value="4"></el-option>
                  <el-option label="终端派送号" value="5"></el-option>
                  <el-option label="货号:尺码" value="6"></el-option>
                  <el-option label="转运公司账号" value="7"></el-option>
                  <el-option label="下单账号" value="8"></el-option>
                </el-select>
                <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
              </el-input>
            </div>
          </div>
          <div class="isMobile">
              <div class="search-bar">
                <span v-if="role==1 || single_type==2" class="export" @click="exportExcel">{{ isExporting?'导出中':'导出excel' }}</span>
                <span v-loading="isExporting"></span>
                <el-select v-model="form.date" class="mobile-select" style="width:150px;margin-right:13px;">
                  <el-option v-for="(date,index) in dateList" :key="index" :label="date" :value="date"></el-option>
                </el-select>
                <el-input class="commbo-input" style="width:500px;" :placeholder="keyword_type=='0'?'':'多个号码请用空格或逗号分隔'" clearable v-model="searchWord">
                  <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择" style="width:120px;" @change="changeKeywordType">
                    <el-option label="全文搜索" value="0"></el-option>
                    <el-option label="任务号" value="1"></el-option>
                    <el-option label="商家订单号" value="2"></el-option>
                    <el-option label="商家物流号" value="3"></el-option>
                    <el-option label="转运物流号" value="4"></el-option>
                    <el-option label="终端派送号" value="5"></el-option>
                    <el-option label="货号:尺码" value="6"></el-option>
                  </el-select>
                  <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
                </el-input>
              </div>
              <div class="search-bar">
                <span>
                  {{totalCount}}个任务&nbsp;&nbsp;
                </span>
              </div>
          </div>
        </template>
        <template v-else>
          <div class="search-bar">
            <div style="display:flex;align-items: center;">
              <span>{{totalCount}}个任务&nbsp;&nbsp;</span>
              <div style="margin:0 20px;">
                <el-date-picker format="yyyy-MM-dd HH:mm" v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" @change="handleTimeChange">
                </el-date-picker>
              </div>
              <div>
                <el-select v-model="form.status" class="mobile-select" style="width:150px;">
                  <el-option v-for="(status,index) in statusList" :key="index" :label="status.label" :value="status.name"></el-option>
                </el-select>
              </div>
            </div>
            <div>
              <el-input class="commbo-input" style="width:400px;" :placeholder="keyword_type=='0'?'':'多个号码请用空格或逗号分隔'" clearable v-model="searchWord">
                <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
              </el-input>
            </div>
          </div>
        </template>
      </el-row>
    </div>
    <div v-if="orders && totalCount > 0" class="orders-container">
      <!--<div style="margin-bottom:-30px;">
        <span>
          <label>时间</label>
          <span class="caret-wrapper" @click="sort" style="margin-left:-5px;">
            <i class="el-icon-caret-top" style="position:relative;top:5px;" :class="{'active':sortParams.time=='asc'}"></i>
            <i class="el-icon-caret-bottom" style="position:relative;top:-2px;" :class="{'active':sortParams.time=='desc'}"></i>
          </span>
        </span>
      </div>-->
      <Order
        v-on:Modify="Modify"
        :needGetMail="true"
        :needGetTicket="true"
        :showHead="true"
        :bussinessList="bussinessList"
        :transportStatusArray="transportStatusArray"
        :singleList="singleList"
        :order="order"
        :isSingle="isSingle"
        :expressList="expressList"
        :delegates="delegates"
        :supportAccountList="supportAccountList"
        :supportEditAccountList="supportEditAccountList"
        :buyers="buyers"
        :exceptionTypes="exceptionTypes"
        :exceptionCategories="exceptionCategories"
        :exceptionTemplateList="exceptionTemplateList"
        :replyTemplateList="replyTemplateList"
        :addressList="addressList"
        :ticketStatus="ticketStatus"
        :ticketPriorities="ticketPriorities"
        :ticketAccounts="ticketAccounts"
        :ticketTypes="ticketTypes"
        :ticketVisible="ticketVisible"
        :merchants="totalMerchants"
        :bindedAccountList="bindedAccountList"
        :replyTemplate="replyTemplate"
        v-for="(order,index) in orders"
        :key="index" @refresh="updatePriceInfo" @searchBuyer="searchBuyer">
      </Order>
    </div>
    <div class="yd-pagination" v-if="totalCount / form.limit > 1">
      <el-pagination
        :page-size="form.limit"
        :pager-count="5"
        :current-page.sync="form.page"
        layout="prev, pager, next"
        next-text="下一页"
        prev-text="上一页"
        :total="totalCount"
        @current-change="pageChangeHandler">
      </el-pagination>
    </div>
    <div v-if="totalCount === 0 && havKeyword" class="empty-orders-container">
      <Loading v-if="!orders"></Loading>
      <p v-if="totalCount === 0 && havKeyword">没有符合条件的任务。</p>
    </div>
  </div>
</template>

<script>
import Order from './Order'
import api from '../../../services/api.js'
import { InternationalAmountStatusArray } from '../../../services/constant.js'
import Loading from '../../../components/Loading'
let _ = require('lodash')

export default {
  name: 'Orders',
  props: ['type', 'isSingle','expressList','delegates','supportAccountList','supportEditAccountList'],
  components: {
    Order: Order,
    Loading: Loading
  },
  async created () {
    localStorage.removeItem('taskfilter_timeRange')
    if(this.$localStorage.get('volumnWarning'))
      this.volumnOn=this.$localStorage.get('volumnWarning')=='1'?true:false
    if(localStorage.getItem('taskfilter_timeRange_new'))
      this.timeRange=JSON.parse(localStorage.getItem('taskfilter_timeRange_new'))
    else{
      this.timeRange=[new Date(new Date().getTime()-3*24*3600*1000),new Date()]
    }
    window.removeEventListener('keydown',this.pageChange)
    //console.log('ceshi2',this.$decimalFormat(33.705,2))
    this.keyword = this.$route.query.order_no
    this.form.page = Number(this.$route.query.page || 1)
    this.form.status = 'all'
    this.form.export_type = 'all'
    this.role = this.$localStorage.get("role")
    //this.buyer_id=this.$localStorage.get("select_buyer_id")?this.$localStorage.get("select_buyer_id"):''
    this.getGroupBussinessList()
    this.getSingleList()
    this.getEarliestDate()
    this.getTransportStatusArray()
    this.getExceptionTypeList()
    this.getAddressList()

    await this.getTicketAccount()
    await this.getTicketTypes()
    await this.getTicketStatus()
    await this.getTicketPriorities()
    await this.getReplyTemplate()
    await this.getTicketVisible()
    await this.getTotalMerchants()
    await this.getUserBindedAccountList()
    this.searchWarpper()

    //this.getExcetionStatusList()
    window.addEventListener('keydown',this.pageChange)
  },
  beforeDestroy() {
    this.endPoolListInterval()
    window.removeEventListener('keydown',this.pageChange)
  },
  computed: {
    single_type () {
	    return this.$store.state.single_type
    },
    dialogOpen () {
	    return this.$store.state.isOpenDialog
    },
  },
  data () {
    return {
      timeChanged:false,
      timeRange:[],
      role:0,
      merchantOptions:[],
      sortParams:{
        field:'timedesc'
      },
      form: {
        date: '最近3个月',
        to_date: null,
        from_date: null,
        export_type:'',
        page: 1,
        status:'',
        transport_express_id:null,
        limit: 10
      },
      dateList: [
        '最近30天',
        '最近3个月',
        '最近6个月'
      ],
      statusList: [
        {label: '任务状态', name: 'all'},
        {label: '待支付', name: '12'},
        {label: '待接单', name: '11'},
        {label: '待下单', name: '13,14'},
        {label: '可下单', name: '102'},
        {label: '等补货', name: '101'},
        {label: '待发货', name: '15'},
        {label: '待转运', name: '103'},
        {label: '转运中', name: '104'},
        {label: '待收货', name: '16'},
        {label: '已完成', name: '20'},
        {label: '已取消', name: '30'},
      ],
      keyword_type:'0',
      keyword: null,
      totalCount: null,
      orders: null,
      bussinessList: null,
      singleList: null,
      havKeyword: false,
      searchWord: null,
      transport_express:'',
      searchMerchant:'',
      transport_status:-1,
      international_transport_amount_status:-1,
      payment_type_list:-1,
      payment_type_list_arr:[
        {value:'-1',name:'支付方式'},
        {value:'1',name:'礼卡'},{value:'2',name:'Paypal'},
        {value:'3',name:'银行卡'},{value:'4',name:'支付宝'},
        {value:'5',name:'微信'},{value:'1,2',name:'礼卡+Paypal'},{value:'1,3',name:'礼卡+银行卡'}
      ],
      order_exception_type:-1,
      remoteTrasports:[],
      secondary_type:'0',
      //buyer_id:'',
      buyer_name:'',
      buyer_type:'-1',
      buyers:[],
      searchMerchantInfo:{},
      transportStatusArray:null,
      internationalAmountStatusArray:InternationalAmountStatusArray,
      merchants:[],
      //single_type:this.$localStorage.get('single_type'),
      isExporting:false,
      volumnOn:false,
      exceptionTypes:[],
      exceptionTemplateList:[],
      replyTemplateList:[],
      addressList:[],
      totalBussnies:[],
      ticketAccounts:[],
      ticketStatus:[],
      ticketTypes:[],
      ticketPriorities:[],
      ticketVisible:[],
      totalMerchants:[],
      bindedAccountList:[],
      replyTemplate:''
    }
  },
  methods: {
    async getReplyTemplate(){
      let res = await api.getReplyTemplate(this)
      this.replyTemplate=res.body.result;
    },
    async getTotalMerchants() {
      let res = await api.getOrdersMerchants(this, {})
      res = res.body
      this.totalMerchants = res.result

    },
    async getTicketVisible() {
      let res = await api.getTicketVisible(this)
      this.ticketVisible=res.body.result
    },
    async getTicketAccount() {
      let res = await api.getTicketAccounts(this)
      this.ticketAccounts=res.body.result
    },
    async getTicketStatus () {
      let res = await api.getTicketStatus(this)
      this.ticketStatus=res.body.result
    },
    async getTicketTypes(){
      let res = await api.getTicketTypes(this)
      this.ticketTypes=res.body.result
    },
    async getTicketPriorities(){
      let res = await api.getTicketPriorities(this)
      this.ticketPriorities=res.body.result
    },
    /*sort(){
      this.sortParams.time=='asc'?this.sortParams.time=='desc':this.sortParams.time=='asc'
      if (this.form.page != 1) {
        this.form.page = 1
      } else {
        this.searchWarpper()
      }
    },*/
    changeDefaultOrder(data){
      if(data!='all')
        this.sortParams.field='timeasc'
    },
    handleTimeChange(){
      console.log('timechange')
      this.timeChanged=true
    },
    pageChangeHandler(){
      this.searchWarpper()
    },
    async getAddressList(){
      let res = await api.getAddressList(this)
      res = res.body
      this.addressList = res.result
    },
    async getPoolList () {
      let res = await api.getPoolList(this, {limit:5})
      if (res.body.status == 'ok') {
        let poolList = res.body.result
        let a=document.getElementById('alertaudio');
        if(poolList.length){
          if(this.single_type=='1' && this.volumnOn)
            a.play()
          else{
            a.currentTime = 0;
	          a.pause();
          }

        }
        else{
          a.currentTime = 0;
	        a.pause();
        }
      }
    },
    endPoolListInterval(){
      if(this.$localStorage.get('pooltimer')){
        clearInterval(+this.$localStorage.get('pooltimer'))
        this.$localStorage.remove('pooltimer')
      }
    },
    getPoolListInterval(){
      if(this.isSingle && this.$localStorage.get('single_type')=='1'){
        if(this.$localStorage.get('pooltimer')){
          clearInterval(+this.$localStorage.get('pooltimer'))
          this.$localStorage.remove('pooltimer')
        }
        if(this.$localStorage.get('token')){
          let timer=setInterval(()=>{
            this.getPoolList()
          },5000)
          this.$localStorage.set('pooltimer',timer)
        }
      }
    },
    exportExcel(){
      this.isExporting=true
      this.searchWarpper(true)
    },
    pageChange(e){
      if(!this.dialogOpen){
        if(this.totalCount / this.form.limit>1){
          switch(e.keyCode){
            case 39:
              if(this.form.page<Math.ceil(this.totalCount / this.form.limit)){
                this.form.page++;
                this.searchWarpper()
              }
              break;
            case 37:
              if(this.form.page>1){
                this.form.page--;
                this.searchWarpper()
              }
              break;
          }
        }
      }
    },
    changeKeywordType(){
      ;
    },
    switchFields(){
      //if(this.secondary_type=='0'){
        this.international_transport_amount_status=-1
        this.transport_status=-1
        this.order_exception_type=-1
        this.payment_type_list='-1'

        //this.searchWarpper()
        //this.getBuyers();
      //}
    },
    transporthandleSelect (item) {
        this.form.transport_express_id = item
        if(!item)
          this.remoteTrasports=[]
    },
    async remotetransportSearch(queryString,callback){
      this.remoteTrasports=[]
      let res=this.expressList.filter((i)=>{
        return i.name.toLowerCase().indexOf(queryString.toLowerCase())>-1
      })
      _.each(res,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
          //this.form.express = item.id
        }
      })
      this.form.transport_express_id = null
      if(callback)
          callback()
    },
    async getUserBindedAccountList(){
      let res = await api.getUserBindedAccountList(this)
      res = res.body
      if (res.status == 'ok') {
        this.bindedAccountList = res.result
      }
    },
    updatePriceInfo(data){
      data.order.price_info=data.price_info;
    },
    /*handleTransportStatus(){
      if (this.form.page != 1) {
        this.form.page = 1
      } else {
        this.searchWarpper()
        //this.getBuyers();
      }
    },*/
    /*handleExceptionType(){
      if (this.form.page != 1) {
        this.form.page = 1
      } else {
        this.searchWarpper()
      }
    },*/
    removeSearchMerchant(value){
      if(!value.target.value){
        this.searchMerchantInfo={};
        if (this.form.page != 1) {
          this.form.page = 1
        } else {
          this.searchWarpper()
          //this.getBuyers();
        }
      }
    },
    handleClear(){
      this.merchantOptions = []
      this.merchants.forEach(item => {
        this.merchantOptions.push({value:item.merchant_name,id:item.merchant_id})
      })
    },
    handleAutoSelect(item){
      this.searchMerchant=item;
      if (this.form.page != 1) {
        this.form.page = 1
      } else {
        if (!this.keyword) {
          this.havKeyword = false
        } else {
          this.havKeyword = true
        }
        //this.totalCount = null
        if (this.searchWord) {
          this.keyword = this.searchWord
        } else {
          this.keyword = null
        }
        //this.sortParams.time='asc'
        /*if(!item)
          this.getOrdersMerchants()
        this.getOrders()
        this.getOrdersCount()*/
      }
    },
    filterSearch(val){
      this.merchantOptions = []
      let mers=[];
      if(val){
        setTimeout(()=>{
          mers=this.totalBussnies.filter((item)=>{
            return item.name.toLowerCase().indexOf(val.toLowerCase())>-1
          }).map((i)=>{return {merchant_name:i.name,merchant_id:i.id}})
          mers.forEach(item => {
            this.merchantOptions.push({value:item.merchant_name,id:item.merchant_id})
          })
        },100)

      }
      else{
        mers=this.merchants;
        mers.forEach(item => {
          this.merchantOptions.push({value:item.merchant_name,id:item.merchant_id})
        })
      }

    },
    async getOrders (isExport) {
      let method=''
      if(isExport)
        method='exportSingleOrders'
      else{
        this.orders = null
        method = this.isSingle ? 'getSingleOrders' : 'getOrders'
      }
      let query = this.createQuery(isExport);
      if(this.timeChanged && window.innerWidth>960)
        localStorage.setItem('taskfilter_timeRange_new',JSON.stringify(this.timeRange))
      let res = await api[method](this, query);
      if(isExport){
        this.isExporting=false
        const href=window.URL.createObjectURL(new Blob([res.body],{type:'application/octet-stream'}))
        const link=document.createElement('a')
        link.href=href
        let name='TaskList'
        let today=new Date()
        name+=today.getFullYear()+(today.getMonth()+1<10?('0'+(today.getMonth()+1)):(today.getMonth()+1))+(today.getDate()<10?'0'+today.getDate():today.getDate())
        let random=Math.random()+''
        random=random.substring(random.indexOf('.')+1,random.indexOf('.')+4)
        name+=random
        link.download=name+'.xlsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
      else{
        res = res.body
        this.orders = res.result
        _.each(this.orders, order => {
          order.copy_goods_list=JSON.parse(JSON.stringify(order.goods_list))
          order.address_info = order.address || {}
          if(order.remark){
            let tempArr=order.remark.split('| ');
            order.iconTitle=tempArr[0];
            if(tempArr.length>1)
              order.realRemark=tempArr[1];
            else
              order.realRemark=order.remark;
          }
          //if(order.status<=15){
            //displayVoucherList字段用于只显示type=4也就是初始发布的图片
            order.displayVoucherList=order.voucher_list.filter(voucher=>voucher.type==4)
          //}
          !(order.fee_adjustment_list[0] && (order.fee_adjustment_list[0].unpaid_fee_rmb && order.fee_adjustment_list[0].status != 4))
          if(order.fee_adjustment_list.length){
            order.noNeedPaid=true;
            for(let i=0,length=order.fee_adjustment_list.length;i<length;i++){
              if(order.fee_adjustment_list[i].offline_payment==0 && order.fee_adjustment_list[i].unpaid_fee_rmb
              && (order.fee_adjustment_list[i].status==0 || order.fee_adjustment_list[i].status==3))
                order.noNeedPaid=false;
                break;
            }
          }
          else{
            order.noNeedPaid=true
          }
        })
        /*this.$router.push(
            {
              path: this.$route.path,
              query: {
                type: this.$route.query.type,
                page: this.form.page,
                order_no: this.$route.query.order_no
              }
            }
        )*/
      }
    },
    createQuery (isExport) {
      let query = Object.assign({}, this.form)
      delete query.order_exception_status;
      console.log('query')
      if(isExport){
        delete query.page
        delete query.limit
        query.need_export=1;
        query.export_type=0
        if(this.transport_express=='581' || this.transport_express=='1590'){
          //美通导出
          query.export_type=1
        }
      }
      delete query.date
      if(this.form.status=='all')
        query.status='';
      query.keyword_type=this.keyword_type
      query.keyword = this.keyword?this.keyword.trim():this.keyword

      if(this.timeRange && window.innerWidth>960){
        query.from_date = this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
        query.to_date = this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
      }
      else{
        let now = +new Date()
        let now_2 = +new Date()+48 * 3600 * 1000
        let past
        let day = 24 * 3600 * 1000
        if (this.form.date === '最近30天') {
          past = now - 30 * day
        } else if (this.form.date === '最近3个月') {
          past = now - 90 * day
        } else if (this.form.date === '最近6个月') {
          past = now - 180 * day
        } else {
          past = this.form.date + '-01-01'
          now = this.form.date + '-12-31'
          now_2 = now
        }

        query.from_date = this.$moment(past).format('YYYY-MM-DD')
        query.to_date = this.$moment(now_2).format('YYYY-MM-DD')
      }

      /*if(this.searchMerchantInfo && this.searchMerchantInfo.id){
        query.merchant_id=this.searchMerchantInfo.id;
      }*/
      if(this.searchMerchant){
        query.merchant_id=this.searchMerchant;
      }
      if(this.transport_status>-1){
        query.transport_status=this.transport_status;
      }

      if(this.international_transport_amount_status>-1){
        query.international_transport_amount_status=this.international_transport_amount_status;
      }

      if(this.payment_type_list>-1){
        query.payment_type_list=this.payment_type_list;
      }

      if(this.order_exception_type!=-1){
        if(this.order_exception_type==999){
          query.order_exception_type_list='-1';
          query.order_exception_type=''
          query.order_exception_status='1'
        }
        else if(this.order_exception_type==-2){
          query.order_exception_type_list='-2';
          query.order_exception_type=this.order_exception_type
          query.order_exception_status='1'
        }
        else{
          query.order_exception_type=this.order_exception_type;
          query.order_exception_status='1'
        }
      }

      query.name_keyword_type=this.buyer_type
      if(this.buyer_name){
        query.name_keyword=this.buyer_name;
        //this.$localStorage.set('select_buyer_id',this.buyer_id);
      }
      if (this.$route.query.order_no) {
        query.from_date = null
        query.to_date = null
      }
      switch(this.sortParams.field){
          case 'timedesc':
            query.order_by_type='desc';
            break;
          case 'timeasc':
            query.order_by_type='asc';
            break;
      }
      return query
    },
    async getOrdersCount () {
      let method = this.isSingle ? 'getSingleOrdersCount' : 'getOrdersCount'
      let query = this.createQuery()
      let res = await api[method](this, query)
      res = res.body
      this.totalCount = Number(res.result)
      let data = {
        totalCount: this.totalCount,
        havKeyword: this.havKeyword
      }
      // if (!this.keyword) {
      this.$emit('totalCount', data)
      // }
    },
    async getOrdersMerchants () {
      let query = this.createQuery()
      delete query.merchant_id
      let res = await api.getOrdersMerchants(this, query)
      res = res.body
      this.merchants = res.result
      this.merchantOptions=[]
      this.merchants.forEach(item => {
        this.merchantOptions.push({value:item.merchant_name,id:item.merchant_id})
      })
    },
    /*async getBuyers () {
      let oldbuyid=this.buyer_id
      this.buyer_id=''
      let query = this.createQuery()
      let res = await api.getBuyers(this, query)
      res = res.body
      this.buyers = res.result
      if(!oldbuyid)
        this.buyer_id="0";
      else
        this.buyer_id=oldbuyid
    },*/
    async getGroupBussinessList () {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.totalBussnies=result;
      this.bussinessList = _.groupBy(result, 'id')
    },
    async getSingleList () {
      let res = await api.getSingleList(this)
      //let result = res.body.result
      //this.singleList = _.groupBy(result, 'id')
      this.singleList=res.body.result
    },
    async getExceptionTypeList () {
      let res = await api.getExceptionTypeList(this)
      this.exceptionTypes=res.body.result.type_list;
      this.exceptionCategories =  res.body.result.category_list;
      this.exceptionTemplateList=res.body.result.sms_template_number_list
      this.replyTemplateList=res.body.result.sms_reply_template_number_list
      console.log('list',this.replyTemplateList)
    },
    /*async getExcetionStatusList () {
      let res = await api.getTransportStatusArray(this)
      this.exceptionStatus=res.body.result;
    },*/
    async getTransportStatusArray () {
      let res = await api.getTransportStatusArray(this)
      this.transportStatusArray=[{id:-1, show:'预报状态'}]
      for(let p in res.body.result){
        res.body.result[p].forEach((i)=>{
          this.transportStatusArray.push({id:i.id,show:i.show,nextStep:i.nextStep,type:p})
        })
      }
    },
    async getEarliestDate () {
      let res = await api.getEarliestDate(this, {
        type: this.isSingle ? 'by_single' : 'by_buyer',
        account_id: this.$localStorage.get('account_id')
      })
      let result = (res.body.result || '').replace(/-/g, '/') || new Date()
      result = new Date(result).getFullYear()
      let currentYear = new Date().getFullYear()

      while (currentYear >= result) {
        this.dateList.push(currentYear)
        currentYear--
      }
    },
    searchBuyer(data){
      this.buyer_type=data.type
      this.buyer_name=data.name;
      this.search()
    },
    async search () {
      this.searchWord=this.searchWord?this.searchWord.replace(/(^\s*)|(\s*$)/g,''):''
      if (!this.keyword) {
        this.havKeyword = false
      } else {
        this.havKeyword = true
      }
      this.totalCount = null
      if (this.searchWord) {
        this.keyword = this.searchWord
      } else {
        this.keyword = null
      }
      if (this.form.page != 1) {
        this.form.page = 1
      } else {
        await this.getOrdersMerchants()
        this.getOrders()
        this.getOrdersCount()
        //this.getBuyers();
      }
    },
    Modify () {
      this.searchWarpper()
      //this.getBuyers();
    },
    async searchWarpper(isExport){
      this.searchWord=this.searchWord?this.searchWord.replace(/(^\s*)|(\s*$)/g,''):''
        if (!this.keyword) {
          this.havKeyword = false
        } else {
          this.havKeyword = true
        }
        if (this.searchWord) {
          this.keyword = this.searchWord
        } else {
          this.keyword = null
        }
        if(isExport){
          this.getOrders(true)
        }
        else{
          this.totalCount = null
          await this.getOrdersMerchants()
          this.getOrders()
          this.getOrdersCount()
        }
    }
  },
  watch: {
    /*form: {
      handler: function (val, oldVal) {
        this.searchWarpper()
        //this.getBuyers();
      },
      deep: true
    },*/
    single_type(val){
      if(val==1){
        this.getPoolList()
        this.getPoolListInterval()
      }
      else
        this.endPoolListInterval()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search-bar{
  display:flex;
  flex-wrap: wrap;
  width:100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
  .revise {
    display:  inline-block;
    width: 100%;
  }
.empty-orders-container {
  font-size:16px;
  color:rgba(102,102,102,1);
  line-height:22px;
  text-align: center;
  padding: 133px 0 200px
}
.yd-pagination {
  position: absolute;
  bottom: -70px;
  width: 100%;
}
.export{
  margin-right:1px;
}
.export:hover{
  text-decoration: underline;
  cursor: pointer;
}
@media screen and (min-width: 961px) {
  .search-bar.notMobile{
      display: flex !important;
    }
    .isMobile {
      display: none !important;
    }
}
  @media screen and (max-width: 960px) {
    .search-bar.notMobile{
      display: none !important;
    }
    .isMobile {
      display: block !important;
    }
    .search-bar{
      flex-wrap: wrap;
    }
    .search-bar>div{
      margin-right:13px;
      margin-bottom: 10px;
    }
    .mobile-select {
      width: 60%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/Orders.vue